interface IProps {
  size?: number;
  color?: string;
}

export default function CutleryIcon({ size = 24, color = 'currentColor' }: IProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 2V11C3 12.1046 3.89543 13 5 13H6V22H8V13H9C10.1046 13 11 12.1046 11 11V2H9V9H8V2H6V9H5V2H3Z"
        fill={color}
      />
      <path
        d="M15 2V9C15 10.6569 16.3431 12 18 12V22H20V2C17.2386 2 15 4.23858 15 7V9H15V2Z"
        fill={color}
      />
    </svg>
  );
}
